export var CLASSNAME_PREFIX = 'av-journey-container';
export var IRELAND_VERIFICATION_FLOW = 'd546';
//# sourceMappingURL=componentConfig.js.map